import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function CANoticePage() {
  useMetaTags({
    title: 'CA Notice at Collection | FindOnlineDegrees',
    description: 'California Consumer Privacy Act notice for FindOnlineDegrees.org'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-713">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-714">
        <div className="max-w-4xl mx-auto text-center" data-id="element-715">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-716">
            CA Notice At Collection
          </h1>
          <p className="text-gray-300 text-sm" data-id="element-717">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-718">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-719">
          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-720">
            <p data-id="element-721">
              This privacy notice for FindOnlineDegrees.org describes how and
              why we might collect, store, use, and/or share your information
              when you use our services, such as when you:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-722">
              <li data-id="element-723">
                Visit our website, or any website of ours that links to this
                privacy notice
              </li>
              <li data-id="element-724">
                Engage with us in other related ways, including any sales,
                marketing, or events
              </li>
            </ul>
            <p className="font-semibold" data-id="element-725">
              Questions or concerns? Reading this privacy notice will help you
              understand your privacy rights and choices. If you do not agree
              with our policies and practices, please do not use our services.
            </p>
          </div>

          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-726">
            <p data-id="element-727">
              If you are a California resident, the California Consumer Privacy
              Act ("CCPA") requires us to provide you with the following notice
              with information about:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-728">
              <li data-id="element-729">
                the purpose for which we use each category of "personal
                information" (as defined in the CCPA) we collect; and
              </li>
              <li data-id="element-730">
                the categories of third parties to which we (a) disclose such
                personal information for a business purpose, (b) "share"
                personal information for "cross-context behavioral advertising,"
                and/or (c) "sell" such personal information.
              </li>
            </ul>
          </div>

          {/* Categories of Personal Information */}
          <div data-id="element-731">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-732">
              Categories of Personal Information We Collect
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-733">
              <p data-id="element-734">
                The table below describes the categories of personal information
                we have collected from California consumers in the preceding 12
                months, the sources from which we collected it, our business or
                commercial purposes for collecting it, and the categories of
                third parties to whom we disclose, share, or sell that
                information.
              </p>
            </div>

            <div className="overflow-x-auto mt-6" data-id="element-735">
              <table className="min-w-full border border-gray-300" data-id="element-736">
                <thead className="bg-gray-50" data-id="element-737">
                  <tr data-id="element-738">
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-739">
                      Category of Personal Information
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-740">
                      Examples
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-741">
                      Collected?
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-742">
                      Sources
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white" data-id="element-743">
                  <tr data-id="element-744">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-745">
                      <strong data-id="element-746">Identifiers</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-747">
                      Name, email address, phone number, IP address, device ID
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-748">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-749">
                      Directly from you via forms, automatically via cookies
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-750">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-751">
                      <strong data-id="element-752">Personal Information (CA Civil Code)</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-753">
                      Name, contact information, education history
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-754">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-755">
                      Directly from you via forms
                    </td>
                  </tr>
                  <tr data-id="element-756">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-757">
                      <strong data-id="element-758">Commercial Information</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-759">
                      Records of services considered or obtained
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-760">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-761">
                      From your interactions with our services
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-762">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-763">
                      <strong data-id="element-764">Internet/Network Activity</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-765">
                      Browsing history, search history, interaction with website
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-766">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-767">
                      Automatically via cookies and analytics
                    </td>
                  </tr>
                  <tr data-id="element-768">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-769">
                      <strong data-id="element-770">Geolocation Data</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-771">
                      Approximate location based on IP address
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-772">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-773">
                      Automatically via IP address
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-774">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-775">
                      <strong data-id="element-776">Inferences</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-777">
                      Preferences, characteristics, behavior
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-778">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-779">
                      Derived from your activity on our services
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Business Purposes */}
          <div data-id="element-780">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-781">
              Business or Commercial Purposes for Collection
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-782">
              <p data-id="element-783">
                We collect and use personal information for the following
                purposes:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-784">
                <li data-id="element-785">To provide, improve, and administer our services</li>
                <li data-id="element-786">
                  To communicate with you, including responding to inquiries
                </li>
                <li data-id="element-787">To ensure security and fraud prevention</li>
                <li data-id="element-788">To comply with legal obligations</li>
                <li data-id="element-789">To deliver targeted advertising and marketing</li>
                <li data-id="element-790">To analyze and improve our website performance</li>
                <li data-id="element-791">To connect you with educational institutions</li>
              </ul>
            </div>
          </div>

          {/* Disclosure of Personal Information */}
          <div data-id="element-792">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-793">
              Disclosure of Personal Information
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-794">
              <p data-id="element-795">
                We may disclose your personal information to the following
                categories of third parties:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-796">
                <li data-id="element-797">Educational institutions and their partners</li>
                <li data-id="element-798">Service providers (analytics, hosting, marketing)</li>
                <li data-id="element-799">Advertising partners and networks</li>
                <li data-id="element-800">Legal and regulatory authorities when required</li>
                <li data-id="element-801">Business partners in connection with business transfers</li>
              </ul>
            </div>
          </div>

          {/* Your Rights */}
          <div data-id="element-802">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-803">
              Your California Privacy Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-804">
              <p data-id="element-805">As a California resident, you have the following rights:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-806">
                <li data-id="element-807">
                  <strong data-id="element-808">Right to Know:</strong> Request disclosure of the
                  categories and specific pieces of personal information we have
                  collected about you.
                </li>
                <li data-id="element-809">
                  <strong data-id="element-810">Right to Delete:</strong> Request deletion of your
                  personal information, subject to certain exceptions.
                </li>
                <li data-id="element-811">
                  <strong data-id="element-812">Right to Correct:</strong> Request correction of
                  inaccurate personal information.
                </li>
                <li data-id="element-813">
                  <strong data-id="element-814">Right to Opt-Out:</strong> Opt out of the "sale" or
                  "sharing" of your personal information for cross-context
                  behavioral advertising.
                </li>
                <li data-id="element-815">
                  <strong data-id="element-816">Right to Limit:</strong> Limit the use and disclosure
                  of sensitive personal information (if applicable).
                </li>
                <li data-id="element-817">
                  <strong data-id="element-818">Right to Non-Discrimination:</strong> You will not
                  receive discriminatory treatment for exercising your privacy
                  rights.
                </li>
              </ul>
            </div>
          </div>

          {/* How to Exercise Rights */}
          <div data-id="element-819">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-820">
              How to Exercise Your Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-821">
              <p data-id="element-822">
                To exercise your rights under the CCPA, please contact us
                through the information provided on our website. We will verify
                your identity before processing your request and respond within
                the timeframes required by law.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-823">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-824">
              Contact Us
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-825">
              <p data-id="element-826">
                If you have questions about this notice or wish to exercise your
                California privacy rights, please contact us through the
                information provided on our website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}